import arrow_back_ios_new from "../../assets/Images/arrow_back_ios_new.png";
import guac from "../../assets/Images/demo/guac_relative_icon.svg";

import "../../assets/css/style.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import "./NudgeMoneyLanding.css"; // Import your CSS file for animations
import { useAsaSession, useIsLoading, useAsaSessionPagesMutation, useBackButton } from '../../services/AsaSessionServices'

import { useActiveSubscriptions, useSubscriptionsPlans, useFintechLayouts,useSubscriptionPurchaseMutation } from '../../services/AsaApiServices'
import { IAsaSession, Plan, SessionPage,SubscriptionDetail } from "../../types/types";

import LoaderComponent from "../../components/LoaderComponent";
import { AnalyticsService, AnalyticsAction, AnalyticsFeature } from "../../services/AnalyticsService";
import {showCustomToast} from '../../services/toastService'
import NudgeMoneySlider,{ISlide} from "./NudgeMoneySlider";
import { useTranslation } from "react-i18next";
import { TFunction } from "react-i18next";

function mapSubscriptionPlan (plan:Plan,
  subscriptions:SubscriptionDetail[] | undefined,
 t: TFunction
):ISlide {

  var isSubscribed=subscriptions?.some(x=> x.asaFintechCode ===plan.asaFintechCode && x.subscriptionPlanCode===plan.subscriptionPlanCode )
  
  const slide:ISlide=
  {

    //icon: kidpay_basic_ico,
    title: plan?.isFree?t("trackManageViewFreeGoals") :t("trackManageViewGoals"),
    description: plan?.description,
    buttonText:isSubscribed ? t("managePlan") : 
    (plan.isFree?t("free"): `$${plan.oneTimeAmount}/${t(plan.billingCycle.toLowerCase())}`),
    //buttonText:`${plan.oneTimeAmount}$/MONTH`
    source:plan,
    subscriptionDetails: plan?.disclosureMessage ?? "",
    termsTitle:  plan?.isFree ? t("freePlanTerms") : t("subscriptionTerms"),
    goals: plan?.isFree? [t("aiGoalsManagement")]:[t("aiGoalsManagement"),t("budgetingtools"),t("linkedaccounts")],
  } as ISlide;

    
    return slide;
}

export default function NudgeMoneyLanding() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isLoading, ] = useIsLoading();

  const { data: session } = useAsaSession()
  const { data: subscriptions } = useActiveSubscriptions()
  const { data: subscriptionsPlans } = useSubscriptionsPlans()
  const sessionMutation = useAsaSessionPagesMutation()

  const handleBackClick = useBackButton()
  const layout = useFintechLayouts()
  const [isShowBackButton, setIsShowBackButton] = useState(true);
  const slides:ISlide[] | undefined=subscriptionsPlans?.map((x)=> mapSubscriptionPlan(x,subscriptions,t));
  const subscriptionPurchaseMutation= useSubscriptionPurchaseMutation()

  useEffect(() => {
    AnalyticsService.track("Nudge Money Landing Viewed", AnalyticsAction.View, AnalyticsFeature.NudgeMoney);
  }, []);

  const saveFreeSubscription = async (plancode:number):Promise<boolean> => {
    const plan=subscriptionsPlans?.find(x=>x.subscriptionPlanCode===plancode)
    try {
    
      const requestData = {
        comment: "Free Plan",
        billingEmail: null,
        isAcceptTerms: true,
        firstName: null,
        middleName: null,
        lastName: null,
        subscriptionPlanCode: plan?.subscriptionPlanCode,
        address: null,
        address2: null,
        city: null,
        state: null,
        country: null,
        postalCode: null,
        couponCode: null,
      };
      await subscriptionPurchaseMutation.mutateAsync(requestData)
      AnalyticsService.track("Nudge Money Free Subscription Success", AnalyticsAction.API_Result, AnalyticsFeature.NudgeMoney, {
        subscriptionName: plan?.subscriptionTitle,
        price: plan?.recurringAmount,
      });
      return true;

    } catch (error) {
      AnalyticsService.track("Nudge Money Free Subscription Error", AnalyticsAction.API_Result, AnalyticsFeature.NudgeMoney, {
        subscriptionName: plan?.subscriptionTitle,
        price: plan?.recurringAmount,
      });
      console.error(error);
    
      showCustomToast("Error select subscriptions",true)
      return false;
    }
  }
  

  const updateSessiongoal = async (
    plan: Plan | undefined,
  ) => {


    const sessionToUpdate: IAsaSession = { ...session } as IAsaSession
    sessionToUpdate.sessionPages = undefined
    const sessionpages = [] as SessionPage[]
    sessionpages.push({
      pageNumber: 2,
      pageName: "GOALS PLANS",
      pageTitle: "Select Package",
      pageDescription: "Select Package",
      pageUrl: "/nudgemoney",
      pageStatusMessage: "INCOMPLETE",
      pageData: JSON.stringify(plan)
    } as SessionPage)
    sessionpages.push({
      pageNumber: 81,
      pageName: 'Landingyes',
      pageTitle: 'Landingyes',
      pageDescription: 'Landingyes',
      pageUrl: '/nudgemoney',
      pageData: JSON.stringify({ Landing: "true" })
    } as SessionPage
    )

   
    try {

      const response = await sessionMutation.mutateAsync({ asaSession: sessionToUpdate, extraPages: sessionpages })
      AnalyticsService.track("Nudge Money Session Update Success", AnalyticsAction.API_Result, AnalyticsFeature.NudgeMoney, {
        subscriptionName: plan?.subscriptionTitle,
        price: plan?.recurringAmount,
      });
      return response;
    } catch (error) {
      AnalyticsService.track("Nudge Money Session Update Error", AnalyticsAction.API_Result, AnalyticsFeature.NudgeMoney, {
        subscriptionName: plan?.subscriptionTitle,
        price: plan?.recurringAmount,
      });

      console.error("Error updating session:", error);

    }
  };
  // Handling Update Session response

  const handleSlideClick = async (plan:Plan | undefined) => {
    AnalyticsService.track("Nudge Money Plan Clicked", AnalyticsAction.Click, AnalyticsFeature.NudgeMoney, {
      subscriptionName: plan?.subscriptionTitle,
      price: plan?.recurringAmount,
      billingCycle: plan?.billingCycle,
    });

    if(!!!plan) {
      showCustomToast("No subscription plan selected",true)
      
      return;
    }
    
    if (subscriptions?.some((x) => x.subscriptionPlanCode === plan.subscriptionPlanCode )) {
    
      navigate("/manageSubscriptions");
    } 
    else if(plan.isFree) {
    
      const result=await saveFreeSubscription(plan.subscriptionPlanCode);
      if(!result) {
        return;
      }
      let successDynamicLink = null;
      const targetPage = session?.sessionPages?.find(page => page.pageNumber === 0);
      if (targetPage) {
        const pageData = JSON.parse(targetPage.pageData);
        successDynamicLink = pageData.successDynamicLink;
      }
      if (successDynamicLink) {
        window.location.href = successDynamicLink;
      } else {
        console.error("Back action dynamic link not found.");
      }
    }
    else {
      await updateSessiongoal(plan);
      navigate("/subscriptionpayment");
    }

  }

  return (
    <div className="flex justify-center items-center overflo h-screen">
      <LoaderComponent />
      <div className="w-full h-full flex flex-col  text-white relative z-20"
        style={layout?.backGroundStyle}>
         
        <div className="flex items-center justify-between p-4 mt-2 h-[72px]">
        { isShowBackButton && 
          <span className="back-arrow"
            style={layout?.buttonStyle}>
            <img
              alt="back"
              onClick={handleBackClick}
              className="cursor-pointer p-2 shadow-2xl rounded-lg w-7 h-7"
              src={arrow_back_ios_new}
            />
          </span>
      }
        </div>
          
        <div
          className="flex-grow relative rounded-t-3xl mt-6 p-6 flex flex-col bg-[#EBECF0] dark:bg-[#121212]"
          
        >
       
          <div className="flex justify-center items-center -mt-20">
            <img
              alt="Guac"
              src={layout?.appIcon}
              className="w-20 h-20 rounded-2xl"
            />
          </div>
          <div className="flex flex-grow flex-col  mt-2">
            <div className="flex flex-col">
              <span className="text-[#4E4E4E] dark:text-[#FDFDFD] font-poppins text-center text-xl/5 font-bold">
               {layout?.appName ?? "Nudge Money"}
            </span>
            </div>
            <div className="flex flex-col ">
              {!!subscriptionsPlans &&
                <NudgeMoneySlider
                  slides={slides}
                  onSlideClick={handleSlideClick}
                  isSubscribed={subscriptions?.some(() => true) ?? false}
                  isExistSubscriptionPlans={subscriptionsPlans?.some(() => true) ?? false}
                  layout={layout}
                  setIsShowBackButton={setIsShowBackButton}
                />
      }
              {/* <CustomSlider slides={slides} /> */}
            </div>


          </div>
        </div>
      </div>
    </div>
  );
}
